module.exports = __webpack_public_path__ + "img/bidToMachineFlow.7a2149ff.gif";